import { render } from "./CIS-Content-Two-Column.vue?vue&type=template&id=be1d4198&scoped=true"
import script from "./CIS-Content-Two-Column.vue?vue&type=script&lang=js"
export * from "./CIS-Content-Two-Column.vue?vue&type=script&lang=js"

import "./CIS-Content-Two-Column.vue?vue&type=style&index=0&id=be1d4198&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1d4198"]])

export default __exports__